import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { getSDM18HCLs } from '../../data/SDM18HCL/actions';

class SDM18HCL extends PureComponent {
    static propTypes = {
        initialized: PropTypes.bool.isRequired,
        getSDM18HCLs: PropTypes.func.isRequired,
        SDM18HCLs: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshSDM18HCLs();
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `SDM18HCL/detail/${rowData.id}` });
    };

    /* ACTIONS */
    refreshSDM18HCLs = () => {
        const { getSDM18HCLs } = this.props;
        this.setState({ loading: true });
        return getSDM18HCLs()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    /* RENDER */
    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRight = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`general.products.SDM18HCL.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshSDM18HCLs
                }
            ]
        };
        if (profile.get('admin') || userRight.includes('SDM18HCLDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate(`general.showDetail`),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderData = memoizeOne(SDM18HCLs => {
        let result = [];
        SDM18HCLs.map(SDM18HCL => {
            result.push({
                id: SDM18HCL.get('macAddress'),
                macAddress: SDM18HCL.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                addressIp: SDM18HCL.get('addressIp'),
                email: SDM18HCL.get('userEmail'),
                label: SDM18HCL.get('label'),
                state: SDM18HCL.getIn(['state'], false) ? Translator.translate(`general.${SDM18HCL.get('state')}`) : null,
                firmwareVersion: SDM18HCL.get('firmwareVersion'),
                usersList: SDM18HCL.get('usersList'),
                userMasterId: SDM18HCL.get('userMasterId')
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('SDM18HCLDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.addressIp'),
                name: 'addressIp'
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            }
        ];
    });
    render() {
        const { loading } = this.state;
        const { profile, SDM18HCLs, history } = this.props;

        return (
            <FHETable
                idTable="SDM18HCLList"
                columns={this.renderColumns(profile)}
                data={this.renderData(SDM18HCLs)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`general.products.SDM18HCL.table.title`)}
                emptyDataSourceMessage={Translator.translate(`general.products.SDM18HCL.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const users = state.environments[history.environment].data.Users.get('list');
    let SDM18HCLs = state.environments[history.environment].data.SDM18HCL.get('list');
    SDM18HCLs = SDM18HCLs.map(SDM18HCL => {
        const masterId = SDM18HCL.getIn(['userMasterId'], '');
        return SDM18HCL.setIn(['userEmail'], users.getIn([masterId && masterId.toString(), 'email'], ''));
    });

    return {
        profile: state.data.user,
        SDM18HCLs,
        initialized: state.environments[history.environment].data.SDM18HCL.get('initialized')
    };
}
const styles = theme => ({
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getSDM18HCLs }, dispatch)
    )(withStyles(styles, { withTheme: true })(SDM18HCL))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/SDM18HCL/index.js